export default {
  methods: {
    getFullCurrency(currencyRate) {
      let currentCurrencyRate = null;
      let currentCurrencyResult = null;
      if(currencyRate.minValue !== null && currencyRate.maxValue !== null) {
        if (currencyRate.minValue === currencyRate.maxValue)
          currentCurrencyRate = `${currencyRate.minValue} ${currencyRate.sourceCurrencyCode}`;
        else
          currentCurrencyRate = `${currencyRate.minValue} - ${currencyRate.maxValue} ${currencyRate.sourceCurrencyCode}`;
      } else {
        currentCurrencyRate = `${currencyRate.sourceCurrencyCode}`;
      }

      if(currencyRate.currencyRateSource === 'Import') {
        let currentFrequency = `${this.$t('CONTENT.currency.currencyRate_imported')}`;
        let [firstLetter, ...tail] = currentFrequency;
        let smallFrequency = firstLetter.toLowerCase() + tail.join('');
        currentCurrencyResult = `${currentCurrencyRate} ${smallFrequency}`;
      } else {
        currentCurrencyResult = currentCurrencyRate;
      }

      return currentCurrencyResult;
    }
  }
};
